import { Person } from "@/services/DTOs/Person";
import { trackAPICall } from "@/services/SnowplowService";
import { isTorreEmail } from "@/utils/TesterUtil";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { OpportunitiesApiService } from "./OpportunitiesApiService";
import { SolarApiService } from "./SolarApiService";

class Service {
  public getUserData(): Observable<Person> {
    const url = "/api/suite/users/me";

    return OpportunitiesApiService.get(url)
      .pipe(map((response) => {
        const data = response.data;
        const canary = { canary: !!data.email && isTorreEmail(data.email) };

        return new Person({ ...data, ...canary });
      }));
  }

  public getUserServices(): Observable<number[]> {
    const url = "/api/suite/users/me/services";

    return OpportunitiesApiService.get(url)
      .pipe(map((response) => response.data as number[] ));
  }

  @trackAPICall("PUT", "Person", "locale", (args) => ({ locale: args[0] }))
  public updateLocale(publicId: string, locale: string): Observable<void> {
    const url = `/api/genome/people/${publicId}`;
    return SolarApiService.put(url, { locale }).pipe(map(() => undefined));
  }

  public geolocate(): Observable<{ name?: string }> {
    const url = "/api/suite/users/me/geolocate";

    return OpportunitiesApiService.get(url)
      .pipe(map((response) => response.data));
  }
}

export const UserService = new Service();
